"use client";
import { AppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import { LinkLikeComponentProps } from "@shopify/polaris/build/ts/src/utilities/link";
import Link from "next/link";
import { ReactNode } from "react";

const containsId = (s: string): boolean => {
  return s.split("/").some((part) => /[a-z]{2}-[a-z0-9]{25}/.test(part));
};

function LinkWrapper(props: LinkLikeComponentProps) {
  const { children, url, ref, ...rest } = props;
  // const [hasHovered, setHasHovered] = useState(false);

  return (
    <Link
      prefetch={!containsId(url)}
      href={url}
      ref={ref}
      {...rest}
      // onMouseOver={
      //   !hasHovered
      //     ? () => {
      //         setHasHovered(true);
      //       }
      //     : undefined
      // }
    >
      {children}
    </Link>
  );
}

export default function ThemeRegistry({ children }: { children: ReactNode }) {
  return (
    <AppProvider i18n={enTranslations} linkComponent={LinkWrapper}>
      {children}
    </AppProvider>
  );
}
